import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear session on component mount
    sessionStorage.removeItem("user"); 
    sessionStorage.removeItem("user_id"); 
    sessionStorage.removeItem("email"); 
    sessionStorage.removeItem("company_id"); 
    sessionStorage.removeItem("branch_id"); 
    sessionStorage.removeItem("token"); 

    sessionStorage.removeItem("order_id"); 
    sessionStorage.removeItem("selectedTables"); 
    sessionStorage.removeItem("orderType"); 
    sessionStorage.removeItem("order"); 
    // or sessionStorage.clear();

    // Redirect to login page
    navigate("/login");
  }, [navigate]);

  return null; // no UI needed
}

export default Logout;
